module.exports = __webpack_public_path__ + "static/media/lending-tools4.890f1bc8.svg";